import { Profitability } from '@optimizer/models';
import {
  RESET_POINT_OF_SALE_STATE,
  RESET_PRODUCT_BOOSTED_DATA
} from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const priceProfitabilitySuccess = (state, priceProfitability) => {
  state.priceProfitability = priceProfitability;
};

const isPriceProfitabilityLoadingToggle = (state) => {
  state.isPriceProfitabilityLoading = !state.isPriceProfitabilityLoading;
};

const boostedProductsSuccess = (state, boostedProductSet) => {
  state.boostedProductSet = boostedProductSet;
};

const boostedMenuProductsSuccess = (state, boostedMenuProductSet) => {
  state.boostedMenuProductSet = boostedMenuProductSet;
};

const resetProductBoostedData = (state) => {
  state.priceProfitability = new Profitability();
  state.boostedMenuProductSet = new Set();
  state.boostedProductSet = new Set();
};

const resetPointOfSaleState = (state) => {
  state.priceProfitability = new Profitability();
  state.boostedMenuProductSet = new Set();
  state.boostedProductSet = new Set();
  state.menuEngineering.periodEngineeringProfitability = null;
  state.menuEngineering.isEngineeringProfitabilityLoading = false;
};

const resetMenuEngineeringProfitability = (state) => {
  state.menuEngineering.periodEngineeringProfitability = null;
  state.menuEngineering.isEngineeringProfitabilityLoading = false;
};

export const mutations = {
  [MutationTypes.PRICE_PROFITABILITY_SUCCESS]: priceProfitabilitySuccess,
  [MutationTypes.IS_PRICE_PROFITABILITY_LOADING_TOGGLE]: isPriceProfitabilityLoadingToggle,
  [MutationTypes.BOOSTED_PRODUCT_SET_SUCCESS]: boostedProductsSuccess,
  [MutationTypes.BOOSTED_MENU_PRODUCT_SET_SUCCESS]: boostedMenuProductsSuccess,
  [MutationTypes.RESET_MENU_ENGINEERING_PROFITABILITY]: resetMenuEngineeringProfitability,
  [RESET_POINT_OF_SALE_STATE]: resetPointOfSaleState,
  [RESET_PRODUCT_BOOSTED_DATA]: resetProductBoostedData,
};
